import { render, staticRenderFns } from "./StoreGroupbuyingUpdateImage.vue?vue&type=template&id=37a21080&scoped=true&"
import script from "./StoreGroupbuyingUpdateImage.vue?vue&type=script&lang=js&"
export * from "./StoreGroupbuyingUpdateImage.vue?vue&type=script&lang=js&"
import style0 from "./StoreGroupbuyingUpdateImage.vue?vue&type=style&index=0&id=37a21080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a21080",
  null
  
)

export default component.exports